import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({
  salesData,
  colName,
  setOpen,
  setUpdateModalData,
  updateModalData,
  data,
}) => {
  const [selectedIndex, setIndex] = useState(-1);
  return (
    <Box
      sx={{
        p: { xs: "10px", sm: "10px 20px" },
        background: "white",
        borderRadius: "10px",
        width: "100%",
        ml:{xs:2, sm:0}
      }}
    >
      <Grid container spacing={1} pl={2}>
        {/* Header Row */}
        <Grid
          container
          spacing={1}
          sx={{
            borderBottom: "1px solid #1E1E1E",
            py: 1,
            pr: { xs: 1, sm: 5 },
          }}
        >
          <Grid item xs={4} sm={4}>
            <Typography
              align="center"
              color="primary"
              fontSize={{ xs: "12px", sm: "15px" }}
              fontWeight={500}
            >
              Date
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4}>
            <Typography
              align="center"
              color="primary"
              fontSize={{ xs: "12px", sm: "15px" }}
              fontWeight={500}
            >
              Category
            </Typography>
          </Grid>
          <Grid item xs={4} sm={3}>
            <Box sx={{ textAlign: { xs: "left", sm: "center" } }}>
              <Typography
                color="primary"
                fontSize={{ xs: "12px", sm: "15px" }}
                fontWeight={500}
              >
                Total
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Scrollable Content */}
        <Box
          sx={{
            maxHeight: "50vh",
            overflowY: "auto",
            width: "100%",
            pr: { xs: 1, sm: 2 },
          }}
        >
          {data.map((item, idx) => (
            <Grid item xs={12} key={idx} sx={{ my: 0.5 }}>
              <Accordion
                expanded={selectedIndex === idx}
                onChange={() => setIndex(selectedIndex === idx ? -1 : idx)}
                sx={{
                  borderRadius: "20px",
                  backgroundColor:
                    selectedIndex === idx ? "#01008B" : "#E3E3FF",
                  boxShadow: "none",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        color: selectedIndex === idx ? "white" : "#01008B",
                      }}
                    />
                  }
                  sx={{
                    borderRadius: "20px",
                    backgroundColor:
                      selectedIndex === idx ? "#01008B" : "#E3E3FF",
                    py: 1,
                  }}
                >
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={4} sm={4}>
                      <Typography
                        align="center"
                        fontSize={{ xs: "10px", sm: "15px" }}
                        color={selectedIndex === idx ? "white" : "black"}
                        noWrap
                      >
                        {convertDateToCustomFormat(item.date.split("T")[0])}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography
                        align="center"
                        fontSize={{ xs: "10px", sm: "15px" }}
                        color={selectedIndex === idx ? "white" : "black"}
                      >
                        {item.category}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} sx={{ textAlign: "center" }}>
                      <Typography
                        fontSize={{ xs: "10px", sm: "15px" }}
                        color={selectedIndex === idx ? "white" : "black"}
                      >
                        ₹ {item.amount?.toFixed(2)}
                      </Typography>
                    </Grid>
                    <Grid item xs={1} sm={1} sx={{ textAlign: "center" }}>
                      <EditIcon
                        sx={{
                          fontSize: { xs: "12px", sm: "14px" },
                          color: selectedIndex === idx ? "white" : "#01008B",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpen(true);
                          setUpdateModalData({
                            date: dayjs(item.date.split("T")[0]),
                            id: item.id,
                            expenseItemArrProps: item.expenseDetails,
                            filterByProp: item.category,
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails sx={{ background: "#E3E3FF", p: 2 }}>
                  {/* Table header */}
                  <Grid container spacing={1} sx={{ pb: 1 }}>
                    <Grid item xs={8}>
                      <Typography
                        fontSize={{ xs: "12px", sm: "15px" }}
                        fontWeight={500}
                        pl={2}
                      >
                        Item Description
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        fontSize={{ xs: "12px", sm: "15px" }}
                        fontWeight={500}
                        align="right"
                      >
                        Amount
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Details Items */}
                  {item.expenseDetails.map((detail, i) => (
                    <Grid
                      container
                      key={i}
                      spacing={1}
                      sx={{ borderBottom: "1px solid #7D7D7D", pb: 1, mb: 1 }}
                    >
                      <Grid item xs={8}>
                        <Typography
                          fontSize={{ xs: "12px", sm: "15px" }}
                          pl={2}
                          noWrap
                        >
                          {detail.description}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          fontSize={{ xs: "12px", sm: "15px" }}
                          align="right"
                        >
                          ₹ {detail.amount?.toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))}
        </Box>
      </Grid>
    </Box>
  );
};

export default TableReport;
